import { fixTime } from "helpers/dateTools"
import { formatCustomDate } from "helpers/dateTools"
import { validateObject } from "helpers/validateObject"
import { saveSettlement } from "redux/actions/routesStatus/routesStatusAction"
import { cleanURLTicket } from "redux/actions/routesStatus/routesStatusAction"
import { setSnackbar } from "redux/actions/search/searchActions"

const { cleanSettlement } = require("redux/actions/routesStatus/routesStatusAction")

export const navigateToSettlement = (searchType, dispatch, hist) => {
  dispatch(cleanSettlement())
  searchType
    ? hist.push('/admin/lista-liquidaciones')
    : hist.push('/admin/inicio_fin_ruta')
}

export const submitSettlementView = (settlement, dispatch, type, hist, toLiquidations = {}, printConfig) => {
  const { unit, driver, helper, secondHelper, routes, services,
    creditAmount, cashAmount, total, litersTransfers, kilosTransfers,
    totalLitersSold, totalKilosSold, totalTransfers, dispenser, notes, totalReport, sgc, id, kgBulk } = settlement

  const isPortable = unit.type === 'PORTATIL'

  const creditAmountNum = Number(creditAmount?.toFixed(2) || 0);
  const cashAmountNum = Number(cashAmount?.toFixed(2) || 0);
  const totalSaleNum = Number(total?.toFixed(2) || 0);
  const litersTransfersNum = Number(litersTransfers?.toFixed(2) || 0);
  const kilosTransfersNum = Number(kilosTransfers?.toFixed(2) || 0);
  const totalLitersSoldNum = Number(totalLitersSold?.toFixed(2) || 0);
  const totalKilosSoldNum = Number(totalKilosSold?.toFixed(2) || 0);
  const totalTransfersNum = Number(totalTransfers?.toFixed(2) || 0);

  const notesToSend = notes.filter(n => !n.skip).map(note => {
    return {
      ...note,
      id: note?.id.length < 20 ? null : note.id,
    }
  })
  
  const numbersToValidate = [
    creditAmountNum, cashAmountNum, totalSaleNum, litersTransfersNum,
    kilosTransfersNum, totalLitersSoldNum, totalKilosSoldNum, totalTransfersNum
  ];
  
  if (numbersToValidate.some(isNaN)) {
    return dispatch(setSnackbar('Todos los valores deben ser números válidos', 'warning'));
  }

  let form = {
    ...settlement,
    id,
    idUnit: unit.id,
    idDriver: driver.id,
    idHelper: helper?.id,
    idSecondHelper: secondHelper?.id,
    username: unit.username,
    type: unit.type,
    unitNumber: unit.number,
    idStartRoute: routes?.start?.id,
    idEndRoute: routes?.end?.id,
    idDispenser: dispenser ? dispenser.id : null,
    services,
    creditAmount: creditAmountNum,
    cashAmount: cashAmountNum,
    totalSale: totalSaleNum,
    total: totalSaleNum,
    litersTransfers: litersTransfersNum,
    kilosTransfers: kilosTransfersNum,
    totalLitersSold: totalLitersSoldNum,
    totalKilosSold: totalKilosSoldNum,
    totalTransfers: totalTransfersNum,
    sgc,
    kgBulk,
    printConfig: printConfig,
    date: settlement?.routes?.end?.time,
    notes: notesToSend,
  }
  
  if ((isPortable && totalReport !== totalKilosSoldNum) || (!isPortable && totalReport !== totalLitersSoldNum && totalSaleNum !== totalReport)) {
    const sCil10 = routes.start.endowments.sCil10
    const sCil20 = routes.start.endowments.sCil20
    const sCil30 = routes.start.endowments.sCil30
    const sCil45 = routes.start.endowments.sCil45
    const eCil10 = routes.end.endowments.sCil10
    const eCil20 = routes.end.endowments.sCil20
    const eCil30 = routes.end.endowments.sCil30
    const eCil45 = routes.end.endowments.sCil45

    const total = (sCil10 - eCil10) * 10 + (sCil20 - eCil20) * 20 + (sCil30 - eCil30) * 30 + (sCil45 - eCil45) * 45
    if (total !== totalReport || total !== totalKilosSoldNum) return dispatch(setSnackbar('Los totales de las Dotaciones No Coinciden'))
    return dispatch(setSnackbar('Los totales No Coinciden'))
  }
  if (totalReport === 0 || (isPortable && totalKilosSoldNum === 0) || (!isPortable && totalLitersSoldNum === 0)) {
    return dispatch(setSnackbar('Los totales No pueden ser 0'))
  }

  if (notes.filter(nt => nt.methodPayment === "CONDONACION" && !nt.deleted).length > 0) {
    dispatch(setSnackbar('Faltan confirmar condonaciones', 'warning'))
  }

  const {
    totalDiscountNotes,
    totalReport: tReport,
    totalValidateNotes,
    ...cleanForm

  } = form

  dispatch(saveSettlement(cleanForm, unit?.type, hist, unit?.unitManualConf, toLiquidations))
}

export const handleTypeUnit = (settlement, setTypeUnit, unit, settlementLoading, message, handleNav) => {
  validateObject(settlement) && settlement && setTypeUnit(unit.type === 'PORTATIL' ? false : true)
  if (validateObject(settlement, true) && !settlementLoading) {
    message.length === 0 && handleNav()
  }
}

export const cleanURLTicketPrint = (dispatch) => {
  dispatch(cleanURLTicket())
  dispatch(cleanSettlement())
}
